// extracted by mini-css-extract-plugin
module.exports = {"renderContent":"RenderContent_renderContent__23z2u"};